export default function fieldsToStructure(fields) {
  const structure = {};
  fields.forEach(field =>
    structure[field] = function (item) {
      return item[field + 'Id'] || item[field];
    },
  );
  return structure;
}
